module.exports = __webpack_public_path__ + "media/images/application/template/logos/mcs-09c58fbc9dd8678b4bba8df46fec0858.png";